import script from "./ActivityRegistrations.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityRegistrations.vue?vue&type=script&setup=true&lang=js"

import "./ActivityRegistrations.vue?vue&type=style&index=0&id=3c8e6e36&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c8e6e36"]])

export default __exports__